import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { IPHistDashboardPage, JCAHistDashboardPage } from '../components'

export const IP3HistRouter = () => {
  return (
    <Routes>
      <Route path="/ip" element={<IPHistDashboardPage />} />
      <Route path="/jca" element={<JCAHistDashboardPage />} />

      <Route path="*" element={<Navigate to="/ip" />} />
    </Routes>
  )
}
